export class RmCountPriceListRequest{
    id:number
    minValue:number
    maxValue:number
    count:number
    price:number
    createduser:string
    updateuser:string
    constructor(
        id:number,
        minValue:number,
        maxValue:number,
        count:number,
        price:number,
        createduser:string,
        updateuser:string
    ){
        this.id=id
        this.minValue=minValue
        this.maxValue=maxValue
        this.count=count
        this.createduser=createduser
        this.price=price
        this.updateuser=updateuser
    }
}